export default "__VITE_ASSET__7acc934e__"